module.exports = __webpack_public_path__ + "static/media/GelBoxBuffer.ebe9aa40.svg";